export enum CollapsibleBlock {
  COLLAPSED_PROJECT_BUILDTYPELINE = 'COLLAPSED_PROJECT_BUILDTYPELINE',
  COLLAPSED_PROJECT_PIPELINE = 'COLLAPSED_PROJECT_PIPELINE',
  COLLAPSED_BRANCHES_SECTION = 'COLLAPSED_BRANCHES_SECTION',
  COLLAPSED_PROJECT_BLOCK = 'COLLAPSED_PROJECT_BLOCK',
  COLLAPSED_AGENT_POOLS = 'COLLAPSED_AGENT_POOLS',
  COLLAPSED_SUBPROJECT = 'COLLAPSED_SUBPROJECT',
}
